<template>
    <h1>Order Summary</h1>
</template>

<script>
export default {
    components: {
        
    },
    props: [
        
    ],
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
        
    }
};
</script>

<style>

</style>
